(function(root, factory) {
	
	'use strict';
	
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as a named module.
		define('morphdom-opts', factory);
	} else {
		// Browser globals
		root.MORPHDOM_OPTS = factory();
	}
}(this, function() {
	
	'use strict';
	const EVENTS = [
	    'onclick', 'ondblclick', 'onmousedown', 'onmouseup', 'onmouseover', 'onmousemove', 'onmouseout',
	    'ondragstart', 'ondrag', 'ondragenter', 'ondragleave', 'ondragover', 'ondrop', 'ondragend',
	    'onkeydown', 'onkeypress', 'onkeyup',
	    'onunload', 'onabort', 'onerror',
	    'onresize', 'onscroll',
	    'onselect', 'onchange', 'onsubmit', 'onreset',
	    'onfocus', 'onblur',
	    'oninput', 'oncontextmenu', 'onfocusin', 'onfocusout',
	    'onload'
	]
	
	const MORPHDOM_OPTS = {
	    // Based on yo-yo's use of morphdom: Copy event attributes as well
	    //https://github.com/maxogden/yo-yo/blob/73416171dd8fb687ed80a7d7ed135557334499ba/index.js#L18-L35
	    onBeforeElUpdated: function(fromEl, toEl) {
	        for (var i = 0, l = EVENTS.length; i < l; i++) {
	            var ev = EVENTS[i]
	            if (toEl[ev]) {              // If new element has a whitelisted attribute
	                fromEl[ev] = toEl[ev]    // update existing element,
	            } else if (fromEl[ev]) {     // If existing element has it and new one doesnt
	                fromEl[ev] = undefined   // remove it from existing element
	            }
	        }
	
	        MORPHDOM_OPTS.onNodeAdded(toEl)
	        return true;
	    },
	
	    onNodeAdded: function(node) {
	        if (node && node.onload) {
	            // @TODO: Wrap this in an actual onload event
	            node.onload(node)
	        }
	    },
	}
	
	return MORPHDOM_OPTS;
}));

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
